
export default {
  props: {
    name: {type: String, required: true},
    size: {type: Number, required: true},
    ext: {type: String, default: undefined},
    error: {type: Boolean, default: false},
    failed: {type: Boolean, default: false},
    processing: {type: Boolean, default: false},
    removing: {type: Boolean, default: false}
  },
  emits: ['remove', 'retry'],
}
